export const DocumentStatus = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
};
